import React from 'react';
import {
  Filter,
  ReferenceInput,
  ReferenceArrayInput,
  AutocompleteInput,
  SelectInput,
  SelectArrayInput,
  TextInput,
  BooleanInput,
} from 'react-admin';
import { PROD_STATUSES, LICENSE_TYPES } from '../../constants';

const ProductsFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
      <TextInput label="Artwork Name" source="name" allowEmpty />
      <SelectInput source="status" choices={PROD_STATUSES} />
      <SelectInput source="license_type" choices={LICENSE_TYPES} />
      {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
        <ReferenceInput
          source="provider_id"
          reference="users"
          sort={{ field: 'first_name', order: 'ASC' }}
          filter={{ role_id: [0,1,2] }}
          fullWidth
        >
          <AutocompleteInput optionText={(record) => record.id ? `${record.first_name} ${record.last_name}` : ''} />
        </ReferenceInput>
      )}
      <ReferenceInput
        label="Host"
        source="host_id"
        reference="hosts"
        sort={{ field: 'name', order: 'ASC' }}
        perPage={1000}
        fullWidth
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Artist"
        source="artist_id"
        reference="artists"
        sort={{ field: 'first_name', order: 'ASC' }}
        perPage={1000}
        fullWidth
      >
        <AutocompleteInput optionText={(record) => record.id ? `${record.first_name} ${record.last_name}` : ''} />
      </ReferenceInput>
      <BooleanInput source="wall" defaultValue={true} />
      <BooleanInput source="staff_pick" />
      <ReferenceInput
        label="Art Type"
        source="art_type_id"
        reference="art-types"
        sort={{ field: 'id', order: 'ASC' }}
        fullWidth
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceArrayInput
        label="Category"
        source="categories"
        reference="categories"
        filter={{ parent_id: null }}
        sort={{ field: 'name', order: 'ASC' }}
        fullWidth
        style={{ minWidth: 150 }}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};
export default ProductsFilter;
